import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import StitchHeader from '../components/StitchHeader';
import { getBaleInitData } from '../services/bale';
import '../styles/Home.css';

function Home() {
  const navigate = useNavigate();
  const howItWorksRef = useRef(null);

  useEffect(() => {
    getBaleInitData();
  }, []);

  const scrollToHowItWorks = () => {
    howItWorksRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="stitch-home">
      <StitchHeader />

      <main>
        <section className="stitch-home-hero stitch-home-shell">
          <div className="stitch-hero-copy">
            <span className="stitch-eyebrow">یک بازی ساده برای نزدیک‌تر شدن</span>
            <h1>دوستات چقدر تو رو می‌شناسن؟</h1>
            <p>
              یک چالش سرگرم‌کننده بساز، لینک اختصاصی‌اش را برای دوستات بفرست و ببین چه کسی
              واقعاً تو را بهتر می‌شناسد.
            </p>
            <div className="stitch-hero-actions">
              <button className="stitch-primary-button" type="button" onClick={() => navigate('/create')}>
                همین حالا شروع کن <span aria-hidden="true">←</span>
              </button>
              <button className="stitch-outline-button" type="button" onClick={scrollToHowItWorks}>
                ببین چطور کار می‌کند
              </button>
            </div>
            <div className="stitch-social-proof">
              <div className="stitch-avatar-stack" aria-hidden="true">
                <img src="/stitch/home/participant-1.png" alt="" />
                <img src="/stitch/home/participant-2.png" alt="" />
                <img src="/stitch/home/participant-3.png" alt="" />
              </div>
              <span>بیش از <strong>۱۲٬۴۰۰</strong> کوییز ساخته شده</span>
            </div>
          </div>

          <div className="stitch-hero-art" aria-hidden="true">
            <img src="/stitch/home/hero-illustration.png" alt="" />
            <div className="stitch-answer-toast">
              <span className="stitch-heart">♥</span>
              <div>
                <strong>علیرضا جواب داد!</strong>
                <small>امتیاز: ۹ از ۱۰</small>
              </div>
            </div>
          </div>
        </section>

        <section className="stitch-how-section" ref={howItWorksRef}>
          <div className="stitch-home-shell">
            <div className="stitch-section-heading">
              <span>خیلی ساده است</span>
              <h2>چطوری بازی کنیم؟</h2>
            </div>
            <div className="stitch-steps-grid">
              <article className="stitch-step-card">
                <span className="stitch-step-icon stitch-icon-indigo">✎</span>
                <h3>۱. سوالات را بساز</h3>
                <p>از بین سوال‌های جذاب انتخاب کن و پاسخ درست هرکدام را مشخص کن.</p>
              </article>
              <article className="stitch-step-card stitch-step-card-featured">
                <span className="stitch-step-icon stitch-icon-rose">↗</span>
                <h3>۲. لینک را بفرست</h3>
                <p>لینک اختصاصی چالش را در واتس‌اپ، تلگرام یا اینستاگرام به اشتراک بگذار.</p>
              </article>
              <article className="stitch-step-card">
                <span className="stitch-step-icon stitch-icon-green">★</span>
                <h3>۳. نتایج را ببین</h3>
                <p>ببین چه کسی تو را بهتر می‌شناسد و نتیجه‌ها را در داشبورد دنبال کن.</p>
              </article>
            </div>
          </div>
        </section>

        <section className="stitch-final-cta stitch-home-shell">
          <div>
            <span>رایگان و آمادهٔ شروع</span>
            <h2>آماده‌ای دوستات را به چالش بکشی؟</h2>
            <p>اولین چالش خودت را بساز و ببین چه کسی واقعاً دوست صمیمی توست.</p>
          </div>
          <button className="stitch-white-button" type="button" onClick={() => navigate('/create')}>
            ساخت چالش جدید
          </button>
        </section>
      </main>

      <footer className="stitch-home-footer">
        <div className="stitch-home-shell stitch-footer-content">
          <div>
            <strong>چقدر منو می‌شناسی؟</strong>
            <p>یک راه سرگرم‌کننده برای شناختن آدم‌های مهم زندگی.</p>
          </div>
          <nav aria-label="پیوندهای پایین صفحه">
            <button type="button" onClick={() => navigate('/premium')}>نسخه حرفه‌ای</button>
            <button type="button" onClick={() => navigate('/login')}>ورود</button>
            <button type="button" onClick={() => navigate('/create')}>ساخت آزمون</button>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export default Home;
